export default {
  en: {
    'components.spreadsheet.column-header.row-id': 'Row id',
    'components.spreadsheet.column-header.invoice-number': 'Invoice Number',
    'components.spreadsheet.column-header.invoice-date': 'Invoice Date',
    'components.spreadsheet.column-header.partner-name': 'Partner Name',
    'components.spreadsheet.column-header.partner-country': 'Partner Country',
    'components.spreadsheet.column-header.ec-vat-no': 'EC VAT No.',
    'components.spreadsheet.column-header.ccy': 'Ccy',
    'components.spreadsheet.column-header.net': 'Net',
    'components.spreadsheet.column-header.vat': 'VAT',
    'components.spreadsheet.column-header.gross': 'Gross',
    'components.spreadsheet.column-header.client-transaction-type': 'Client Transaction Type',
    'components.spreadsheet.column-header.comments': 'Comments',
  },
};
